import { io } from 'socket.io-client';

let socket = null;

export function connectSocket(userId) {
  if (socket?.connected) {
    socket.emit('join', userId);
    return socket;
  }

  const url = process.env.VUE_APP_STRAPI_URL || '';
  socket = io(url, { path: '/ws', transports: ['websocket'] });

  socket.on('connect', () => {
    socket.emit('join', userId);
  });

  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
